import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from 'src/utils/baseQuery';

import type { IContact } from '../contacts.types';

export const contactsApi = createApi({
  reducerPath: 'contactsApi',
  baseQuery,
  endpoints: (builder) => ({
    getContactsList: builder.mutation({
      query: (defaultFilter) => ({
        url: 'contact/list',
        method: 'POST',
        body: defaultFilter,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: {
        data?: { contact?: { list?: IContact[]; total?: number } };
      }) => {
        const obj = {
          list:
            response?.data?.contact?.list?.map((item) => ({
              ...item,
              // labels,
            })) ?? [],
          total: response?.data?.contact?.total ?? 0,
        };

        return obj;
      },
    }),
    createContact: builder.mutation<IContact, Partial<IContact>>({
      query: (newAccount) => ({
        url: 'contact/add',
        method: 'POST',
        body: newAccount,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    updateContact: builder.mutation<IContact, { id: string; updates: Partial<IContact> }>({
      query: ({ id, updates }) => ({
        url: `contact/update`,
        method: 'POST',
        body: { id, ...updates },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    filterContact: builder.mutation({
      query: (filterQuery) => ({
        url: `contact/list`,
        method: 'POST',
        body: filterQuery,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: {
        data?: { contact?: { list?: IContact[]; total?: number } };
      }) => {
        const obj = {
          list:
            response?.data?.contact?.list?.map((item) => ({
              ...item,
              // labels,
            })) ?? [],
          total: response?.data?.contact?.total ?? 0,
        };

        return obj;
      },
    }),
    getContactDtl: builder.mutation({
      query: (id: string) => ({
        url: 'contact/details',
        method: 'POST',
        body: { id },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    deleteContacts: builder.mutation({
      query: (ids: string[]) => ({
        url: 'contact/delete',
        method: 'POST',
        body: { ids },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    importContact: builder.mutation({
      query: (filePath) => ({
        url: 'contact/import',
        method: 'POST',
        body: filePath,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    exportcontact: builder.mutation({
      query: (filter) => ({
        url: 'contact/export',
        method: 'POST',
        body: filter,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    })
  }),
});

export const {
  useGetContactsListMutation,
  useCreateContactMutation,
  useUpdateContactMutation,
  useFilterContactMutation,
  useGetContactDtlMutation,
  useDeleteContactsMutation,
  useImportContactMutation,
  useExportcontactMutation
} = contactsApi;
